const Section2 = () => {
  return (
    <section>
      <div className="px-10 mt-10">
        <h1 className="text-xl lg:text-2xl font-bold mb-5">About the content</h1>
        <p className="text-sm mb-5">
          The content is carefully designed to be phonics-based, sequential, and
          learner-friendly, ensuring measurable progress in spelling and
          literacy skills.
        </p>
        <h2 className="font-bold">Key highlights of the content include:</h2>
        <ul className="list-disc ml-5 px-4 text-sm">
          <li>Structured lessons focused on spelling rules and patterns</li>
          <li>
            Skill-building activities that improve reading and writing accuracy
          </li>
          <li>
            Strategies that help students apply spelling knowledge independently
          </li>
          <li>
            A progression-based design that supports long-term literacy
            development
          </li>
        </ul>
        <p className="text-sm mt-5">
          The program is provided as a single program option or as a complete
          bundle of all four programs, giving you flexibility based on your
          needs.
        </p>
      </div>
    </section>
  );
};

export default Section2;
   